import validate from 'validate.js';
import lang from '../lang/validation.json';
import isoDate from './validators/isoDate.js';
import { set } from './lodashInJS.js';

validate.validators.isoDate = isoDate;

//va setter les translations
const keys = Object.keys(lang);
for (const i in keys) {
  if (validate.validators[keys[i]]) {
    const data = lang[keys[i]];
    if (typeof data !== 'string') {
      Object.keys(data).forEach((message) => {
        validate.validators[keys[i]][message] = data[message];
      });
    } else {
      validate.validators[keys[i]].message = lang[keys[i]];
    }
  }
}

function transformNestedResults(results) {
  if (!results) {
    return;
  }

  const output = {};
  const result = Object.keys(results);
  for (const i in result) {
    set(output, result[i], results[result[i]]);
  }

  return output;
}

export default function (data, constraints) {
  return transformNestedResults(
    validate(data, constraints, {fullMessages: false})
  );
}